<template>
    <steps-option
        @updateNavigation="updateNavigation"
        :noColors="true"
    />
</template>

<script>
    import StepsOption from './StepsOption.vue';

    export default {
        components: {
            StepsOption,
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },
        },

        beforeDestroy() {
            this.getSnapshot();
        },

        methods: {
            updateNavigation(navRules) {
                // There should always be the next group because Pets step move.
                this.$emit('updateNavigation', navRules);
            },

            async getSnapshot() {
                const popSnapshot = await this.$store.dispatch('snapshot', {
                    view: 'SnapshotPop',
                    onlyController: this.viewController,
                });

                this.$store.dispatch('setCartImageByController', popSnapshot);
            },
        },
    };
</script>
